/***
 * module naming rule
 * @Description English language
 * example [level 1 route]_[level 2 route]_...
 */
export default {
    "us_mall": {
        "feature_one": "Free, fast shipping",
        "feature_two": "Free, easy return",
        "feature_three": "6-Month Warranty",
        "quantity": "Quantity:",
        "tax_tips": "Tax caculation",
        "buy": "Buy Now",
        "check_out": "Check out",
        "select_one": "Please select one data",
    },
    "product": {
        "choose_device_title": "Choose your device",
        "choose_package_title": "Choose your initial data package",
        "choose_accessory_title": "Would you like to add accessories?",
        "add_to_cart": "Add to cart",
    },
    "cart": {
        "cart_title": "My Cart",
        "remove": "Remove",
        "total": "TOTAL:",
    },
    "settlement": {
        "title": "SECURE CHECKOUT",
        "delivery": "Delivery",
        "pick_up": "Pick up",
        "form_title": "Enter your name and address",
        "country": "Country*",
        "required": "required field",
        "firstName": "First name*",
        "lastName": "Last name*",
        "address1": "Address line 1*",
        "address2": "Address line 2",
        "city": "City",
        "state": "State/Province/Region*",
        "zipCode": "Zip code*",
        "contactInfo": "Contact information",
        "email": "Email address*",
        "phone": "Phone number*",
        "contact_checked": "Subscribe to our news letter to receive exclusive deals",
        "ship": "Shipping method",
        "payment": "Payment method",
        "pickup_spot": "Available pickup spot",
        "name": "Name*",
        "order_summary": "Order Summary",
        "apply": "Apply",
        "subtotal": "Subtotal",
        "shipping": "Shipping",
        "tax": "Tax",
        "total": "Total:",
        "privacy": "By placing this order, you agree to our<a href=\"/member/agreement\">Terms and Conditions</a> and <a href=\"/users/privacy_policy\">Privacy Policy</a>.",
        "order": "Place Order",
        "paymentCompleted": "Payment Completed",
        "wxScanTips": "Please use wechat to scan",
        "payForWeChat": "WeChat",
    },
    "cooperation": {
        "firstName": "First Name",
        "lastName": "Last Name",
        "position": "Position",
        "companyName": "Company Name",
        "email": "Email",
        "phone": "Phone",
        "address": "Address",
        "productInterst": "Main Product of Interest",
        "estimatedQuantity": "Estimated Quantity of Product",
    }
}



// WEBPACK FOOTER //
// ./src/lang/tw/usmall.js